import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FEATURED } from "../lib/content";
import { WEDDINGS } from "../lib/weddings";
import { Reveal, MaskText } from "../components/Motion";

export const FeaturedWork = () => (
  <section data-testid="featured-work" className="bg-paper-2 py-24 md:py-40">
    <div className="max-w-[1500px] mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-24">
        <div>
          <Reveal><p className="text-sand-deep text-[11px] uppercase tracking-[0.3em] mb-6">Featured weddings</p></Reveal>
          <MaskText as="h2" className="font-serif text-4xl sm:text-5xl lg:text-7xl leading-[0.95] text-ink" lines={["Real days,", "real people."]} />
        </div>
        <Reveal delay={0.15}>
          <Link to="/gallery/portfolio/" data-testid="featured-view-all" className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-ink link-underline">
            View full portfolio <ArrowUpRight size={16} />
          </Link>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {FEATURED.map((f, i) => {
          const spans = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7", "md:col-span-6", "md:col-span-6"];
          return (
            <Reveal key={f.couple} delay={(i % 2) * 0.1} className={spans[i]}>
              <Link to={`/gallery/${WEDDINGS[i].slug}/`} data-testid={`featured-${i}`} className="group block">
                <div className="relative overflow-hidden bg-ink/5 aspect-[4/3]">
                  <img
                    src={f.img}
                    alt={f.alt}
                    loading="lazy"
                    className="img-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/10 transition-colors duration-700" />
                </div>
                <div className="flex items-baseline justify-between mt-5">
                  <div>
                    <h3 className="font-serif text-2xl md:text-3xl text-ink">{f.couple}</h3>
                    <p className="text-ink-soft text-sm mt-1">{f.venue} · {f.location}</p>
                  </div>
                  <ArrowUpRight size={20} className="text-sand-deep opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-500" />
                </div>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
